if (!customElements.get('m-manual-cross-sell')) {
  class MManualCrossSell extends HTMLElement {
    constructor() {
      super();
      this.onClickHandler = this.onClick.bind(this);
      this.onChangeHandler = this.onChange.bind(this);
      this.onSubmitHandler = this.onSubmit.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.onClickHandler);
      this.addEventListener('change', this.onChangeHandler);
      this.addEventListener('submit', this.onSubmitHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClickHandler);
      this.removeEventListener('change', this.onChangeHandler);
      this.removeEventListener('submit', this.onSubmitHandler);
    }

    onClick(event) {
      const variantButton = event.target.closest('[data-mcs-variant-button]');
      if (variantButton && this.contains(variantButton)) {
        event.preventDefault();
        this.selectVariant(variantButton);
        return;
      }

      const quantityButton = event.target.closest('[data-mcs-quantity-button]');
      if (quantityButton && this.contains(quantityButton)) {
        event.preventDefault();
        this.updateQuantity(quantityButton);
      }
    }

    onChange(event) {
      const quantityInput = event.target.closest('[data-mcs-quantity-input]');
      if (!quantityInput || !this.contains(quantityInput)) return;

      const value = parseInt(quantityInput.value, 10);
      quantityInput.value = Number.isFinite(value) && value > 0 ? value : 1;
    }

    onSubmit(event) {
      const form = event.target.closest('[data-mcs-form]');
      if (!form || !this.contains(form)) return;

      event.preventDefault();
      this.addToCart(form);
    }

    selectVariant(button) {
      if (button.disabled) return;

      const card = button.closest('[data-mcs-card]');
      const form = button.closest('[data-mcs-form]');
      if (!card || !form) return;

      const variantInput = form.querySelector('[data-mcs-variant-input]');
      const price = card.querySelector('[data-mcs-selected-price]');
      const save = card.querySelector('[data-mcs-save]');
      const saveMoney = card.querySelector('[data-mcs-save-money]');
      const image = card.querySelector('[data-mcs-image]');

      card.querySelectorAll('[data-mcs-variant-button]').forEach((item) => {
        const isActive = item === button;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-checked', isActive ? 'true' : 'false');
      });

      if (variantInput) {
        variantInput.value = button.dataset.variantId || '';
      }

      if (price && button.dataset.variantPrice) {
        price.textContent = button.dataset.variantPrice;
      }

      if (save && saveMoney) {
        const saveAmount = parseInt(button.dataset.saveAmount || '0', 10);
        if (saveAmount > 0) {
          saveMoney.textContent = button.dataset.saveMoney || '';
          save.hidden = false;
        } else {
          save.hidden = true;
        }
      }

      if (image && button.dataset.variantImage) {
        image.src = button.dataset.variantImage;
        image.removeAttribute('srcset');
      }
    }

    updateQuantity(button) {
      const form = button.closest('[data-mcs-form]');
      if (!form) return;

      const input = form.querySelector('[data-mcs-quantity-input]');
      if (!input) return;

      const currentValue = parseInt(input.value, 10);
      const current = Number.isFinite(currentValue) && currentValue > 0 ? currentValue : 1;
      const next = button.dataset.action === 'decrease' ? Math.max(current - 1, 1) : current + 1;

      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    addToCart(form) {
      const submitButton = form.querySelector('[data-mcs-submit]');
      const variantInput = form.querySelector('[name="id"]');

      if (!variantInput || !variantInput.value) {
        this.showMessage(form, this.getErrorText(form), 'error');
        return;
      }

      this.setLoading(form, true);
      this.hideMessage(form);

      const formData = new FormData(form);
      const sectionsToBundle = [];

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );

      formData.append('sections', sectionsToBundle);
      formData.append('sections_url', window.location.pathname);

      const config = this.getFetchConfig(formData);
      const routes = window.MinimogSettings && window.MinimogSettings.routes ? window.MinimogSettings.routes : {};
      const addUrl = routes.cart_add_url || form.getAttribute('action') || '/cart/add.js';

      fetch(addUrl, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleError(form, response, formData);
            return;
          }

          this.handleSuccess(form, response, formData);
        })
        .catch((error) => {
          console.error(error);
          this.showMessage(form, this.getErrorText(form), 'error');
        })
        .finally(() => {
          this.setLoading(form, false);
        });
    }

    getFetchConfig(formData) {
      let config;

      if (typeof fetchConfig === 'function') {
        config = fetchConfig('javascript');
      } else {
        config = {
          method: 'POST',
          headers: {
            Accept: 'application/javascript',
          },
        };
      }

      config.headers = config.headers || {};
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      return config;
    }

    handleError(form, response, formData) {
      const message = response.message || response.description || response.error || this.getErrorText(form);

      if (window.MinimogEvents && window.MinimogTheme && MinimogTheme.pubSubEvents) {
        window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartError, {
          source: 'manual-cross-sell',
          productVariantId: formData.get('id'),
          errors: response.error || response.description,
          message,
        });
      }

      document.dispatchEvent(
        new CustomEvent('product-ajax:error', {
          detail: { errorMessage: message },
        })
      );

      this.showMessage(form, message, 'error');
    }

    handleSuccess(form, response, formData) {
      const settings = window.MinimogSettings || {};
      const strings = window.MinimogStrings || {};
      const cartDrawer = document.querySelector('m-cart-drawer');

      if (settings.use_ajax_atc === false && settings.routes && settings.routes.cart) {
        window.location = settings.routes.cart;
        return;
      }

      if (window.MinimogEvents && window.MinimogTheme && MinimogTheme.pubSubEvents) {
        window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, {
          cart: response,
          productVariantId: formData.get('id'),
        });
      }

      if (cartDrawer && settings.enable_cart_drawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();

        if (window.MinimogTheme && MinimogTheme.Notification && strings.itemAdded) {
          const cartItems = cartDrawer.querySelector('m-cart-items');
          if (cartItems) {
            MinimogTheme.Notification.show({
              target: cartItems,
              method: 'prepend',
              type: 'success',
              message: strings.itemAdded,
              delay: 400,
            });
          }
        }
      } else {
        this.showMessage(form, form.dataset.successText || strings.itemAdded || 'Added', 'success');
      }

      document.dispatchEvent(
        new CustomEvent('product-ajax:added', {
          detail: { product: response },
        })
      );

      this.setSuccessState(form);
    }

    setLoading(form, isLoading) {
      const submitButton = form.querySelector('[data-mcs-submit]');
      if (!submitButton) return;

      submitButton.classList.toggle('is-loading', isLoading);
      submitButton.toggleAttribute('disabled', isLoading);
      submitButton.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    }

    setSuccessState(form) {
      const submitButton = form.querySelector('[data-mcs-submit]');
      const buttonText = form.querySelector('[data-mcs-button-text]');
      if (!submitButton || !buttonText) return;

      const addText = form.dataset.addText || buttonText.textContent;
      const successText = form.dataset.successText || 'Added ✓';

      submitButton.classList.add('is-success');
      buttonText.textContent = successText;

      window.setTimeout(() => {
        submitButton.classList.remove('is-success');
        buttonText.textContent = addText;
      }, 1400);
    }

    showMessage(form, message, type) {
      const messageElement = form.querySelector('[data-mcs-message]');
      if (!messageElement || !message) return;

      messageElement.textContent = message;
      messageElement.hidden = false;
      messageElement.classList.toggle('is-success', type === 'success');
    }

    hideMessage(form) {
      const messageElement = form.querySelector('[data-mcs-message]');
      if (!messageElement) return;

      messageElement.hidden = true;
      messageElement.textContent = '';
      messageElement.classList.remove('is-success');
    }

    getErrorText(form) {
      return form.dataset.errorText || 'Something went wrong';
    }
  }

  customElements.define('m-manual-cross-sell', MManualCrossSell);
}
